import script from "./ExceptionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExceptionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ExceptionPopup.vue?vue&type=style&index=0&id=524bb2c6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524bb2c6"]])

export default __exports__